import Icon from '../../../../common/icons/Icon.js'
import {getState, useSelector} from '../../../../store.js'
import {
  Count,
  Plural,
  PluralBlock,
} from '../../../../common/components/Plural.js'
import OrderFilter from '../../../../common/components/OrderFilter.js'
import ButtonLink from '../../../../common/components/Button/ButtonLink.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import ButtonSecondary from '../../../../common/components/Button/ButtonSecondary.js'
import {showConfirmMessageModal} from '../../../../common/components/Modal/ConfirmMessageModal.js'
import TextArea from '../../../../common/components/TextArea.js'
import {splitStr} from '../../../../common/string.js'

const formName = 'FILTER_PANEL__ORDER_NUMBER'

async function showParseBulkOrderNumberListModal({
  modalFormSelector,
  updateModalForm,
}) {
  await showConfirmMessageModal({
    title: 'Add Order IDs in Bulk',
    Message({form, updateModalForm}) {
      return (
        <div className="margin-top-10 margin-bottom-20">
          <p className="fs-00 lh-md margin-bottom-20">
            Enter Order IDs separated by spaces, line breaks, commas or tabs.
            Put quotes around order numbers if they contain spaces, line breaks,
            commas or tabs {`(example: "Order 123" )`}.
          </p>

          <div className="w-75">
            <TextArea
              label="List of Order IDs"
              id="order_number_str_list"
              value={form.confirmValue}
              onChange={(confirmValue) => updateModalForm({confirmValue})}
              autoFocus
            />
          </div>
        </div>
      )
    },
    modalSize: 'sm',
    confirmText: 'Add Order IDs',
    cancelText: 'Cancel',
    confirmValue: '',
    async onResolve({outcome}) {
      if (!outcome) {
        return
      }

      const {order_number: existingOrderNumbers} = modalFormSelector(getState())
      const newOrderNumbers = splitStr(outcome)

      updateModalForm({
        order_number: [
          ...new Set([...existingOrderNumbers, ...newOrderNumbers]),
        ],
      })
    },
  })
}

export default function OrderNumberFilterPanel({
  modalFormSelector,
  updateModalForm,
}) {
  const modalForm = useSelector(modalFormSelector)
  const orderNumbers = modalForm.order_number
  const totalSelected = orderNumbers.length

  return (
    <div className="wrap--modal-filters wrap--modal-filters-order_numbers">
      <div className="wrap__modal-subheader margin-bottom-25 flex--justify">
        <div>
          <div className="flex">
            <h4 className="fs-01 lh-sm uppercase margin-top-0 margin-bottom-0 flex--justify-col margin-right-10">
              <span>
                <strong>
                  Order ID<span className="lowercase">s</span>
                </strong>
                {totalSelected > 0 && (
                  <PluralBlock count={totalSelected}>
                    <span className="lowercase text--blue margin-left-5">
                      (<Count /> <Plural word="order" p="s" /> added)
                    </span>
                  </PluralBlock>
                )}
              </span>
            </h4>
          </div>
          {totalSelected > 0 && (
            <div className="margin-top-7">
              <ButtonPrimary
                isOutlined
                size="x-sm"
                className="margin-right-5"
                onClick={() =>
                  showParseBulkOrderNumberListModal({
                    modalFormSelector,
                    updateModalForm,
                  })
                }
              >
                Add a List of Order IDs
              </ButtonPrimary>
              <ButtonSecondary
                size="x-sm"
                onClick={() => updateModalForm({order_number: []})}
              >
                Clear All
              </ButtonSecondary>
            </div>
          )}
        </div>

        <div className="wrap--filter-search outer-wrap--product-search-100 w-35">
          <label
            className="label--input-prefix label--search"
            htmlFor="filters_tag_search"
          >
            <Icon name="search" className="icon--input-prefix" />
            <OrderFilter
              dropdown={`${formName}_ORDER_SEARCH`}
              excludedOrderNumbers={orderNumbers}
              onSelect={(order) => {
                updateModalForm({
                  order_number: [
                    ...new Set([...orderNumbers, order.order_number]),
                  ],
                })
              }}
            />
          </label>
        </div>
      </div>
      {totalSelected > 0 ? (
        <ul className="list list--no-style list--modal-filters flex flex-wrap">
          {orderNumbers.map((orderNumber, index) => {
            return (
              <li
                key={index}
                className="list__item list__item--modal-filters list__item--modal-filters-sku"
              >
                <span className="fs-00 lh-md margin-right-5">
                  {orderNumber}
                </span>
                <ButtonLink
                  onClick={() =>
                    updateModalForm({
                      order_number: orderNumbers.filter(
                        (on) => on !== orderNumber,
                      ),
                    })
                  }
                >
                  <Icon name="times" />
                </ButtonLink>
              </li>
            )
          })}
        </ul>
      ) : (
        <div className="list__item--modal-filters-no-results padding-top-15">
          <p className="fs-01 lh-md margin-bottom-20">
            Filter down to specific orders using the search bar.
          </p>
          <ButtonPrimary
            isOutlined
            size="sm"
            onClick={() =>
              showParseBulkOrderNumberListModal({
                modalFormSelector,
                updateModalForm,
              })
            }
          >
            Or Add a List of Order IDs
          </ButtonPrimary>
        </div>
      )}
    </div>
  )
}
